import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Button, UncontrolledTooltip } from "reactstrap";
import { translationHookOptions } from "../../../app/localization/localization";
import { RootStoreContext } from "../../../app/stores/rootStore";
import ProtectedDownload from "../../common/ProtectedDownload";
import { IDownloadButton } from "../../../app/models/toolbar";

interface IParams {
  disabled: boolean;
  inProgress: boolean;
  url: string;
  contentId: number;
  isOpen: boolean;
  button: IDownloadButton;
}

const CustomDownloadButton: React.FC<IParams> = ({
  disabled,
  inProgress,
  url,
  contentId,
  isOpen,
  button
}) => {
  const rootStore = useContext(RootStoreContext);
  
  const { customWatermark } = rootStore.commonStore;
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["browse_page", "toast"], translationHookOptions);

  const handleClick = () => {
    customWatermark(contentId)
      .then()
      .catch(() => toast.error(t("custom_download_error", { ns: "toast" })));
  };
  const [singleTooltip, setIsSingleTooltip] = useState("");
  return (
    <>
      {!disabled && !inProgress ? (
        // <Col xs={3}>
        <div className="text-center mr-2 toolbarButton">
          <Button
            id="custom"
            className={classNames(
              "w-100 h-100 mr-2 px-1 pt-1 pb-1 toolbarButton transparentButton",
              `${theme!.toolbarIconColor}`
            )}
            // style={{ backgroundColor: "white" }}
            // color={!inProgress ? "" : "success"}
            color=""
            disabled={disabled}
            onClick={(e) => handleClick()}
            onMouseEnter={() => setIsSingleTooltip(button.type)}
                onMouseLeave={() => setIsSingleTooltip("")}
          >
            {/* <h6 className="font-size-80 ">custom</h6> */}
            <i className="far fa-file-pdf iconToolbarButton"></i>
            <h6 className="textToolbarButton mb-0">
              {t("toolbar_download_button")}
            </h6>
          </Button>
          <UncontrolledTooltip
            delay={0}
            placement="bottom"
            target="custom"
            isOpen={isOpen || singleTooltip === button.type}
          >
            {t("toolbar_download_button_custom")}
          </UncontrolledTooltip>
        </div>
      ) : (
        // </Col>
        // <Col xs={3}>
        <div className="text-center mr-2 toolbarButton">
          <ProtectedDownload
            hasLoaderModal={true}
            url={url}
            children={
              <Button
              onMouseEnter={() => setIsSingleTooltip(button.type)}
              onMouseLeave={() => setIsSingleTooltip("")}
                id="custom"
                //  style={{ backgroundColor: "white" }}
                className="w-100 h-100 mr-2 px-1 pt-1 pb-1  toolbarButton transparentButton"
                color={!inProgress ? "" : ""}
                disabled={disabled}
              >
                {/* <h6 className="font-size-80 ">custom</h6> */}
                <i className="far fa-file-pdf iconToolbarButton"></i>
                <h6 className="textToolbarButton mb-0">
                  {t("toolbar_download_button")}
                </h6>
              </Button>
            }
          ></ProtectedDownload>
          <UncontrolledTooltip
            delay={0}
            placement="bottom"
            target="custom"
            isOpen={isOpen || singleTooltip === button.type}
          >
            {t("toolbar_download_button_custom")}
          </UncontrolledTooltip>
        </div>
        // </Col>
      )}
    </>
  );
};

export default observer(CustomDownloadButton);
